import { Badge as BadgeIcon, Logout as LogoutIcon } from '@mui/icons-material';
import { Avatar, Box, Button, ListItemButton, Menu, MenuItem, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../../../../routes/Routes';
import { useGetEmployeeById } from '../../../../services/react-query/employees/useGetEmployeeById';
import { useLogoutEmployee } from '../../../../services/react-query/employees/useLogoutEmployee';
import { Employee } from '../../../../types/Employee';
import CannyFeedback from '../../../layouts/menuAppBar/CannyFeedback';
import HelpLink from '../../../layouts/menuAppBar/HelpLink';
import { menuItemLayout, userButtonStyles } from './userPopoverStyles';

const UserPopover: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [currentEmployee, setCurrentEmployee] = useState<Employee | null>(null);
  const { data: currentEmployeeData } = useGetEmployeeById({ uuid: 'current' });
  const navigate = useNavigate();

  const { mutate: logoutEmployee } = useLogoutEmployee({
    onSuccessCallback: () => navigate(ROUTE_PATHS.LOGIN),
  });

  useEffect(() => {
    if (currentEmployeeData) {
      setCurrentEmployee(currentEmployeeData);
    }
  }, [currentEmployeeData]);

  const handleLogout = () => logoutEmployee();

  return (
    <Box>
      <Button
        size="large"
        sx={userButtonStyles}
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={(event) => setAnchorEl(event.currentTarget)}
        color="inherit"
        startIcon={<Avatar src={currentEmployee?.avatar_url} alt="avatar" sx={{ width: 30, height: 30 }} />}
      >
        <Typography>{currentEmployee?.display_name || 'User'}</Typography>
      </Button>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        keepMounted
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        sx={{
          '& .MuiList-root': {
            pl: { xs: '13px', md: '0' },
            pr: { xs: '0', md: '15px' },
          },
        }}
      >
        <HelpLink />
        <CannyFeedback />
        <ListItemButton component={Link} to={`/${ROUTE_PATHS.USER_SETTINGS}`} sx={menuItemLayout}>
          <BadgeIcon color="action" />
          <Typography>Profile</Typography>
        </ListItemButton>

        <MenuItem onClick={handleLogout} sx={menuItemLayout}>
          <LogoutIcon color="action" />
          <Typography>Log Out</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default UserPopover;
